export enum SortFunc {
  Asc = 'asc',
  Desc = 'desc',
}
